import React from 'lib/react';
import {
  EVTabs, EVSkeleton, EVPaper, EVGrid,
} from 'lib/components';
import clsx from 'lib/clsx';
import OrderPreferencesStyles from './OrderPreferencesStyles';
import { getTabListItems } from './OrderPreferences.utils';

function OrderPreferenceLoader() {
  const classes = OrderPreferencesStyles();
  const tabListItems = getTabListItems();

  return (
    <EVGrid container className={classes.orderPreferencesContainer}>
      <EVPaper className={classes.orderPreferencesPaper}>
        <EVGrid className={classes.tabsContainer}>
          <EVTabs
            orientation="vertical"
            variant="scrollable"
            aria-label="tab-list"
            className={classes.tabList}
          >
            {/* #genai stable key from the tab item id */}
            {tabListItems.map((tabItem) => (
              <EVGrid key={tabItem.id} className={classes.tabsContainerSkeleton}>
                <EVSkeleton
                  className={classes.tabElementSkeleton}
                  animation="wave"
                  variant="rect"
                />
              </EVGrid>
            ))}
          </EVTabs>
          <EVGrid className={classes.fillerGrid} />
        </EVGrid>
        <EVGrid container className={classes.pageContainerSkeleton}>
          <EVGrid className={classes.pageContainerElements}>
            <EVSkeleton
              style={{ height: '36px', width: '100%', borderRadius: '6px' }}
              animation="wave"
              variant="rect"
            />
          </EVGrid>
          <EVGrid className={classes.pageContainerElements}>
            <EVSkeleton
              style={{ height: '64px', width: '100%', borderRadius: '6px' }}
              animation="wave"
              variant="rect"
            />
          </EVGrid>
          <EVGrid className={classes.pageContainerElements}>
            <EVSkeleton style={{ height: '44px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
            <EVSkeleton style={{ height: '44px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
            <EVSkeleton style={{ height: '44px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
            <EVSkeleton style={{ height: '44px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid className={clsx(classes.pageContainerElements, 'endBox')}>
            <EVSkeleton style={{ height: '44px', width: '169px', borderRadius: '6px' }} animation="wave" variant="rect" />
          </EVGrid>
        </EVGrid>
      </EVPaper>
    </EVGrid>
  );
}

export default OrderPreferenceLoader;
